export class ApprovalHistoryRecord {
  /**
 * userId: number
 * Description: The user ID.
 */
  userId: number;

  /**
   * userDescription: string
   * Description: The description of the user.
   */
  userDescription: string;

  /**
   * dateOfChange: Date
   * Description: The date of the change.
   * Default value is the current date.
   */
  dateOfChange: Date = new Date();

  /**
   * property: string
   * Description: The property related to the change.
   */
  property: string;

  /**
   * comment: string
   * Description: The comment for the change.
   */
  comment: string;

  /**
   * isApproved: boolean
   * Description: A boolean indicating whether the change is approved.
   */
  isApproved: boolean;

  /**
   * isGeneralHistory: boolean
   * Description: A boolean indicating whether it is a general history.
   */
  isGeneralHistory: boolean;

  /**
   * projectName: string
   * Description: The name of the project.
   */
  projectName: string;

  /**
   * projectOpportunityId: string
   * Description: The ID of the project opportunity.
   */
  projectOpportunityId: string;

  /**
   * taskName: string
   * Description: The name of the task.
   */
  taskName: string;

  /**
   * Constructor
   * @param data
   */
  constructor(data?: any) {
    if (data) {
      this.userId = data.userId;
      this.userDescription = data.userDescription;
      this.dateOfChange = new Date(data.dateOfChange);
      this.comment = data.comment;
      this.property = data.property;
      this.isApproved = data.isApproved;
      this.isGeneralHistory = data.isGeneralHistory;
      this.projectName = data.projectName;
      this.taskName = data.taskName;
      this.projectOpportunityId = data.projectOpportunityId;
    }
  }
}
